import React from "react";
import { SectionHeader } from "../ui-x";

type Props = {
  title: string;
  description?: string;
  /** Kept for call sites that still pass it; the reference has no edit affordance here. */
  edit?: boolean;
  eyebrow?: string;
  actions?: React.ReactNode;
};

/**
 * Every page opens with this (spec rule 5), so it delegates straight to
 * SectionHeader — one change restyles all ten screens that use it.
 */
const PageIntro = ({ title, description, eyebrow, actions }: Props) => (
  <SectionHeader
    eyebrow={eyebrow}
    title={title}
    description={description}
    actions={actions}
  />
);

export default PageIntro;
